import axios from './interceptors'
// 序列化请求数据，视服务端的要求
import qs from 'qs'

// 公共数据
var commonData = {
  // BankId: '9999',
  // LoginType: 'P',
  // _locale: 'zh_CN',
  // _ChannelId: 'WCB',
  // ChnlId: '61',
  // version: '1.0',
  //appid: 'test001',
  // charset: 'UTF-8',
  // sequenceid: new Date().getTime() + '',
  // timestamp: new Date().getTime() + '',
  //algorithm: 'SHA256withRSA',
  //BranchId: '8010000',
};

export default {
  get(url, params = {}) {
    return axios({
      url,
      method: 'get',
      params
    })
  },
  post(url, data = {}) {
    // let t={UserId: sessionStorage.getItem('userID')==='undefined'||window.sessionStorage.getItem("userID")==='null'||!window.sessionStorage.getItem("userID")?"":JSON.parse(sessionStorage.getItem('userID'))};
    // let ed= Object.assign({}, commonData,t, data);
    return axios({
      url,
      method: 'post',
      data,
    })
  },
  postForm(url, data = {}) {
    let t={UserId: sessionStorage.getItem('userID')==='undefined'||window.sessionStorage.getItem("userID")==='null'||!window.sessionStorage.getItem("userID")?"":JSON.parse(sessionStorage.getItem('userID'))};
    let ed= Object.assign({}, commonData,t, data);
    return axios({
      url,
      method: 'post',
      data: qs.stringify(ed)
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/axios/api.js